<template>

<div class="home">

    <div class="home-head">

        <div class="home-head-logo"><span>ADNAT</span></div>

        <div class="home-head-text">

            <h1>Welcome to<br/>ADNAT Reporting</h1>

            <h2>What is ADNAT?</h2>

            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse ut mattis purus. Quisque ut dui ut nisi fermentum dignissim. Maecenas fermentum augue non ornare porttitor. Sed non facilisis orci. Donec metus elit, viverra ac tortor nec, tincidunt viverra nisi. Curabitur hendrerit risus at nulla convallis, nec viverra orci convallis. Maecenas feugiat eleifend nisi.</p>

        </div>

    </div>

    <div class="home-foot">

        <div class="home-foot-links">

            <ul>
                <li><a href="https://apps.apple.com/gb/app/adnat/id6503638944" class="is-apple"><span>Download on the App store</span></a></li>
                <li><a href="https://play.google.com/store/apps/details?id=com.vhs.adnat&pcampaignid=web_share" class="is-google"><span>Get it on Google Play</span></a></li>
            </ul>

        </div>

        <div class="home-foot-login">

            <h2>Sign In<small>Please enter your details</small></h2>

            <input type="text" v-model="model.username" tabindex="1" placeholder="Your email address" />
            <input type="password" v-model="model.password" tabindex="2" placeholder="Password" />

            <div class="home-foot-login-actions">

                <ul class="home-foot-login-actions-links">
                    <li>By signing in to this services I agree to the <router-link :to="{name: 'Terms'}">Terms and Conditions</router-link></li>
                    <li>Don't have any details to sign in? <a href="#">Contact the ADNAT team</a></li>
                </ul>

                <button type="submit" tabindex="3" class="home-foot-login-actions-submit" :class="{'is-failed': is.failed}" v-on:click="onSubmitClick"><span>Sign in</span></button>

            </div>

            <ul class="home-foot-login-links">
                <li><router-link :to="{name: 'Terms'}">Terms & Conditions</router-link></li>
                <li><router-link :to="{name: 'Privacy'}">Privacy Policy</router-link></li>
                <li><router-link :to="{name: 'Cookies'}">Cookie Policy</router-link></li>
            </ul>

        </div>

    </div>

</div>

</template>

<script>

import axios from 'axios'
import cookies from 'js-cookie'

export default {

    data: function() {
    
        return {
            is: {
                loading: false,
                failed: false
            },
            model: {
                username: '',
                password: ''
            }
        }
    
    },

    methods: {
    
        onSubmitClick: function() {
        
            if (!this.is.loading) {
            
                this.is.loading = true

                this.$api.post('login', this.model).then(function(json) {

                    cookies.set(process.env.VUE_APP_COOKIE, json.key)

                    axios.defaults.headers.common['Authorization'] = json.key

                    this.$store.commit('type', json.type)

                    this.$router.push({
                        name: 'Dashboard'
                    })
                
                }.bind(this), function() {
                
                    this.is.failed = true

                    this.$failure('Sorry, your details were not recognised.')
                
                    this.is.loading = false
                
                }.bind(this))
            
            }

        }
    
    }

}

</script>

<style scoped>

.home {
    min-height: 100vh;
    background-color: #015EB9;
}

.home-head {
    background-color: #fff;
    background-image: url(~@/assets/home.head.png);
    background-repeat: no-repeat;
    background-position: calc(100% + 100px) -200px;
    background-size: 560px 574px;
}

.is-tablet .home-head {
    background-position: calc(100% + 200px) -200px;
}

.is-mobile .home-head {
    background-image: none;
}

.home-head-logo {
    position: absolute;
    top: 36px;
    left: calc(50% - 660px);
    width: 238px;
    height: 68px;
    background-image: url(~@/assets/logo.png);
    background-size: 238px 68px;
}

.is-narrow .home-head-logo,
.is-tablet .home-head-logo {
    left: 20px;
}

.is-mobile .home-head-logo {
    left: 0px;
    width: 100%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
}

.home-head-logo span {
    display: none;
}

.home-head-text {
    padding: 220px 64px 64px 0px;
    max-width: 614px;
    margin: 0px 0px 0px calc(50% + 32px);
}

.is-mobile .home-head-text {
    max-width: 100%;
    margin: 0px;
    padding: 140px 20px 340px 20px;
}

.home-head-text h1 {
    color: #425563;
    font-size: 48px;
    font-weight: 600;
    margin-bottom: 32px;
}

.is-tablet .home-head-text h1 {
    font-size: 32px;
}

.is-mobile .home-head-text h1 {
    font-size: 26px;
    text-align: center;
}

.home-head-text h2 {
    color: #425563;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
}

.is-mobile .home-head-text h2 {
    text-align: center;
}

.home-head-text p {
    color: #707070;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
}

.is-mobile .home-head-text p {
    text-align: center;
}

.home-foot {
    background-image: url(~@/assets/home.foot.png);
    background-position: 50% 0px;
    background-size: 1920px 604px;
    background-repeat: repeat-x;
}

.home-foot-links {
    height: 104px;
    padding: 0px 0px 0px calc(50% + 32px);
}

.is-tablet .home-foot-links,
.is-mobile .home-foot-links {
    padding: 0px;
}

.home-foot-links ul {
    display: flex;
    height: 104px;
    align-items: center;
}

.is-tablet .home-foot-links ul,
.is-mobile .home-foot-links ul {
    justify-content: center;
}

.home-foot-links a {
    display: block;
    background-size: contain;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    height: 52px;
}

.home-foot-links a span {
    display: none;
}

.home-foot-links a.is-apple {
    background-image: url(~@/assets/home.apple.png);
    width: 157px;
    margin-right: 20px;
}

.home-foot-links a.is-google {
    background-image: url(~@/assets/home.google.png);
    width: 177px;
}

.is-mobile .home-foot-links a.is-apple {
    width: 130px;
}

.is-mobile .home-foot-links a.is-google {
    width: 140px;
}

.home-foot-links:before {
    content: '';
    position: absolute;
    display: block;
    right: 50%;
    top: 0px;
    margin-top: -484px;
    margin-right: -80px;
    width: 826px;
    height: 868px;
    z-index: 2;
    pointer-events: none;
    background-image: url(~@/assets/home.mobiles.png);
    background-position: 50% 50%;
    background-size: 826px 868px;
}

.is-narrow .home-foot-links:before {
    right: calc(50% - 50px);
}

.is-tablet .home-foot-links:before {
    right: calc(50% + 50px);
    width: 320px;
    height: 320px;
    background-size: contain;
    background-repeat: no-repeat;
}

.is-mobile .home-foot-links:before {
    left: 0px;
    right: 0px;
    width: 100%;
    height: 320px;
    top: -320px;
    margin-top: 0px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50% 50%;
}

.home-foot-login {
    margin: 0px 0px 0px calc(50% + 32px);
    padding: 40px 20px;
    max-width: 614px;
}

.is-tablet .home-foot-login,
.is-mobile .home-foot-login {
    max-width: 100%;
    margin: 0px;
}

.home-foot-login h2 {
    color: #fff;
    font-weight: bold;
    font-size: 24px;
    line-height: 33px;
    margin-bottom: 20px;
}

.home-foot-login h2 small {
    font-size: 16px;
    font-weight: 300;
    font-style: italic;
    margin-left: 20px;
}

.home-foot-login input {
    width: calc(100% + 40px);
    margin-left: -20px;
    background-color: #fff;
    height: 50px;
    border-radius: 32px;
    color: #333;
    font-size: 16px;
    padding: 0px 20px;
    margin-bottom: 10px;
}

.is-narrow .home-foot-login input,
.is-tablet .home-foot-login input,
.is-mobile .home-foot-login input {
    width: 100%;
    margin-left: 0px;
}

.home-foot-login input::placeholder {
    font-style: italic;
    color: #768692;
}

.home-foot-login-actions {
    display: grid;
    margin-top: 20px;
    grid-template-columns: auto 200px;
    align-items: center;
}

.is-narrow .home-foot-login-actions,
.is-tablet .home-foot-login-actions,
.is-mobile .home-foot-login-actions {
    grid-template-columns: 1fr;
    padding-right: 20px;
}

.home-foot-login-actions-links li {
    color: #fff;
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
}

.is-mobile .home-foot-login-actions-links li {
    text-align: center;
    margin-top: 10px;
}

.home-foot-login-actions-links li a {
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}

.home-foot-login-actions-links li a:hover {
    border-bottom: 1px solid rgba(255, 255, 255, 1);
}

.home-foot-login-actions-submit {
    height: 50px;
    border-radius: 32px;
    line-height: 50px;
    text-align: center;
    background-color: #FFB81C;
    color: #231F20;
    font-size: 16px;
    font-weight: bold;
    margin-right: -20px;
}

.is-narrow .home-foot-login-actions-submit,
.is-tablet .home-foot-login-actions-submit,
.is-mobile .home-foot-login-actions-submit {
    margin-top: 20px;
}

.home-foot-login-actions-submit:hover {
    background-color: #e1a012;
}

.home-foot-login-actions-submit.is-failed {
    background-color: #bd4242;
    color: #fff;
}

.home-foot-login-actions-submit.is-failed:hover {
    background-color: #a53636;
    color: #fff;
}

.home-foot-login-links {
    display: flex;
    justify-content: flex-end;
    margin-top: 64px;
}

.is-mobile .home-foot-login-links {
    justify-content: center;
    margin-top: 40px;
}

.home-foot-login-links li {
    font-size: 12px;
    color: #fff;
    font-weight: 400;
    padding: 3px 20px;
    border-right: 1px solid #fff;
}

.is-mobile .home-foot-login-links li {
    text-align: center;
    line-height: 14px;
}

.home-foot-login-links li:last-child {
    border-right: 0px;
    padding-right: 0px;
}

.is-mobile .home-foot-login-links li:last-child {
    padding-right: 20px;
}

.home-foot-login-links li a:hover {
    border-bottom: 1px solid rgba(255, 255, 255, 1);
}

</style>
